import * as React from 'react';

function SvgPropertyLocaltion(props) {
  return (
    <svg width={14} height={14} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M12.353 3.518a5.664 5.664 0 00-1.248-1.808A5.86 5.86 0 007 .048c-.783 0-1.542.15-2.258.445A5.82 5.82 0 002.896 1.71a5.681 5.681 0 00-1.249 1.808 5.55 5.55 0 00-.46 2.218c0 1.103.265 2.202.784 3.261.417.852 1 1.681 1.734 2.47a13.957 13.957 0 002.944 2.391.686.686 0 00.7 0c.373-.22 1.689-1.044 2.943-2.39.735-.788 1.318-1.62 1.735-2.47.522-1.059.786-2.155.786-3.26 0-.769-.155-1.516-.46-2.219zM7 12.754C5.97 12.1 2.313 9.507 2.313 5.737c0-1.217.486-2.361 1.368-3.224a4.723 4.723 0 013.32-1.34c1.254 0 2.432.476 3.318 1.342a4.47 4.47 0 011.369 3.222c0 3.77-3.658 6.362-4.688 7.017zM7 3.11a2.75 2.75 0 100 5.5 2.75 2.75 0 000-5.5zm1.238 3.988A1.744 1.744 0 017 7.61a1.744 1.744 0 01-1.617-1.08 1.744 1.744 0 01.38-1.907c.331-.331.77-.513 1.237-.513.467 0 .907.182 1.238.513.331.331.512.77.512 1.237 0 .468-.181.907-.512 1.238z"
        fill="#000"
        fillOpacity={0.65}
      />
    </svg>
  );
}

export default SvgPropertyLocaltion;
